import React from 'react';
import styled from 'styled-components';
import {fontSize, wh} from '../../mixins';


const StyledBtn = styled.button`
  background-color: transparent;
  border: none;
  display: inline-block;
  color: #23CBA7;
  cursor: pointer;
  ${fontSize(12)};
  line-height: 18px;
  letter-spacing: -0.128px;
  font-weight: 300;
  
  &:focus,
  &:active {
    outline: none;
  }
`

const StyledText = styled.p`
  ${fontSize(12)};
  ${wh('256px', 'auto')};
  line-height: 18px;
  color: #707070;
  letter-spacing: -0.128px;
  text-align: center;
  font-weight: 300;
  padding-bottom: 40px;
  
  a {
    text-decoration: underline;
  }
`

const onLinkClick = url => window.open(url);

const Terms = () => (
    <StyledText>
        <span>By continuing to use Geozilla, you agree to our</span>
        <StyledBtn onClick={() => onLinkClick('https://geozilla.com/terms-of-use/')} id='link-to-terms'>Terms of Use</StyledBtn>
        <span>and</span>
        <StyledBtn onClick={() => onLinkClick('https://geozilla.com/privacy-policy/')} id='link-to-privacy'>Privacy Policy</StyledBtn>
    </StyledText>
);

export default Terms;